/**
 * Where the browser keeps the bearer token.
 *
 * sessionStorage, not localStorage. localStorage survives browser restarts and
 * is written to disk, so a token left there outlives the session it belongs to
 * by days, on a shared or stolen machine that is a standing credential. The
 * session itself expires after five minutes idle, so persisting the token
 * longer buys nothing and costs a lot.
 *
 * The real credential is the HttpOnly session cookie, which JavaScript cannot
 * read at all; this token is the fallback the API client sends as a bearer
 * header. Because the cookie is still sent on every request, a new tab with an
 * empty sessionStorage is still authenticated.
 */
const ACCESS = "accessToken";
const REFRESH = "refreshToken";

export const tokenStore = {
  getAccess: () => sessionStorage.getItem(ACCESS),
  getRefresh: () => sessionStorage.getItem(REFRESH),

  set(accessToken, refreshToken) {
    if (accessToken) sessionStorage.setItem(ACCESS, accessToken);
    if (refreshToken) sessionStorage.setItem(REFRESH, refreshToken);
  },

  clear() {
    sessionStorage.removeItem(ACCESS);
    sessionStorage.removeItem(REFRESH);
    // Older builds stored tokens in localStorage. Clear those too so a user
    // upgrading to this version does not leave one behind on disk forever.
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
  },
};
